import request from "@/dianwuyi/request";
import cookie from 'js-cookie'
import * as frame from "@/dianwuyi/frame"

export async function wx_config() {
    vant.Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加载中...',
    });
    let _jsData = await request({
        url: "/wx_cp/getJsConf",
        method: "post",
        data: {
            appId: config().corpId,
            agentId: config().agentId,
            uri: window.location.href.split("#")[0]
        }
    })
    wx.config({
        beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: _jsData.data.appId, // 必填，企业微信的corpID，必须是本企业的corpID，不允许跨企业使用
        timestamp: _jsData.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: _jsData.data.nonceStr, // 必填，生成签名的随机串
        signature: _jsData.data.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
        success(res) {

        },
        fail(res){
            alert("wx.config.fail:" + JSON.stringify(res))
        },
        jsApiList: ['agentConfig', 'selectEnterpriseContact', 'getCurExternalContact', 'sendChatMessage', 'openUserProfile', 'getContext'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
    });
    wx.ready(function () {
        agentConfig()
    });

    wx.error(function (res) {
        alert("wx.config.error:" + JSON.stringify(res))
    });
}

export async function agentConfig() {
    let _agentData = await request({
        url: "/wx_cp/getAgentConf",
        method: "post",
        data: {
            corpId: config().corpId,
            agentId: config().agentId,
            uri: window.location.href.split("#")[0]
        },
    })

    wx.agentConfig({
        corpid: config().corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
        agentid: config().agentId, // 必填，企业微信的应用id （e.g. 1000247）
        timestamp: _agentData.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: _agentData.data.nonceStr, // 必填，生成签名的随机串
        signature: _agentData.data.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
        jsApiList: ['selectEnterpriseContact', 'getCurExternalContact', 'sendChatMessage', 'openUserProfile', 'getContext'], //必填，传入需要使用的接口名称
        success: function (res) {
            // alert("agentConfig.success:" + JSON.stringify(res))
            vant.Toast.clear();
        },
        fail: function (res) {
            alert("agentConfig.fail:" + JSON.stringify(res))
            if (res.errMsg.indexOf('function not exist') > -1) {
                alert('版本过低请升级')
            }
        }
    });
}

export function config() {
    return {
        "corpId": "ww79a40578fea405e2",
        agentId: 1000015
    }
}

export async function sendImage(dtl) {
    let _resource = dtl.Resource
    if (dtl.ResourceType == 'video') {
        _resource = dtl.Resource.split("?")[0]
    }
    let _imgData = await request({
        url: "/wx_cp/getMediaId",
        method: "post",
        data: {url: _resource, type: dtl.ResourceType},
    })

    wx.invoke('sendChatMessage', {
        msgtype: "image", //消息类型，必填
        enterChat: true, //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
        image: {
            mediaid: _imgData.data.mediaId, //文本内容
        },
    }, function (res2) {
        wx.invoke('getCurExternalContact', {}, function (res) {
            if (res.err_msg == "getCurExternalContact:ok") {
                let externalUserId = res.userId; //返回当前外部联系人userId
                frame.postBusiness("WXExternalUserFollowResource", {
                    ExternalUserId: externalUserId,
                    ResourceNO: dtl.ResourceNO,
                    OrderIdx: dtl.OrderIdx,
                    Resource: dtl.Resource
                })
            } else {
                //错误处理
            }
        })
    })
}


export async function sendText(dtl) {
    wx.invoke('sendChatMessage', {
        msgtype: "text", //消息类型，必填
        enterChat: true, //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
        text: {
            content: dtl.Resource, //文本内容
        },
    }, function (res) {
        wx.invoke('getCurExternalContact', {}, function (res) {
            if (res.err_msg == "getCurExternalContact:ok") {
                let externalUserId = res.userId; //返回当前外部联系人userId
                frame.postBusiness("WXExternalUserFollowResource", {
                    ExternalUserId: externalUserId,
                    ResourceNO: dtl.ResourceNO,
                    OrderIdx: dtl.OrderIdx,
                    Resource: dtl.Resource
                })
            } else {
                //错误处理
            }
        })
    })
}

export async function getAuthUrl(url) {
    let _url = await request({
        url: "/wx_cp/oauth",
        method: "post",
        data: {url: url},
    })
    return _url.data
}

export async function setAuthCode(code) {
    let _userInfo = await request({
        url: "/wx_cp/authUserInfo",
        method: "post",
        data: {code: code},
    })
    setToken(_userInfo.data.userid)
}

export function getToken() {
    let _userid = cookie.get("token")
    if (!_userid || _userid.length == 0) {
        return null
    } else {
        return _userid
    }
}


export function setToken(userid) {
    cookie.set("token", userid)
}